import React, { Component } from 'react'
import moment from 'moment'
import Footer from '../startse/Footer'
import Header from '../startse/Header'
import ShowCard from '../startse/ShowCard'
import '../static/css/style.css'
import '../static/css/startse.css'

export default class StartSe extends Component {
  constructor () {
    super()
    this.state = {
      organizador: {
        'id': 69,
        'name': 'StartSe',
        'login': 'StartSe'
      },
      events: [{
        id: 1658,
        eventName: "EdTech Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-02-21T07:00:00.000Z",
        endDate: "2019-02-22T07:00:00.000Z",
        urlFriendly: "edtech-conference-2019",
      },
      {
        id: 1659,
        eventName: "Cripto & Blockchain 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-03-28T07:00:00.000Z",
        endDate: "2019-03-29T07:00:00.000Z",
        urlFriendly: "cripto-blockchain-2019",
      },
      {
        id: 1660,
        eventName: "Construtech Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-03-29T07:00:00.000Z",
        endDate: "2019-03-30T07:00:00.000Z",
        urlFriendly: "construtech-conference-2019",
      },
      {
        id: 1661,
        eventName: "Silicon Valley Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-03-30T07:00:00.000Z",
        endDate: "2019-03-31T07:00:00.000Z",
        urlFriendly: "silicon-valley-conference-2019",
      },
      {
        id: 1662,
        eventName: "Govtech Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-04-24T07:00:00.000Z",
        endDate: "2019-04-25T07:00:00.000Z",
        urlFriendly: "govtech-conference-2019",
      },
      {
        id: 1663,
        eventName: "Healthtech Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-04-25T07:00:00.000Z",
        endDate: "2019-04-26T07:00:00.000Z",
        urlFriendly: "healthtech-conference-2019",
      },
      {
        id: 1664,
        eventName: "Fintech Conference 2019",
        address: "Av. Profa. Ida Kolb, 513 - Jardim das Laranjeiras, São Paulo - SP, 02518-000",
        startDate: "2019-05-22T07:00:00.000Z",
        endDate: "2019-05-23T07:00:00.000Z",
        urlFriendly: "fintech-conference-2019",
      },
      {
        id: 1665,
        eventName: "Lawtech Conference 2019",
        address: "Av. Profa. Ida Kolb, 513 - Jardim das Laranjeiras, São Paulo - SP, 02518-000",
        startDate: "2019-05-23T07:00:00.000Z",
        endDate: "2019-05-24T07:00:00.000Z",
        urlFriendly: "lawtech-conference-2019",
      },
      {
        id: 1666,
        eventName: "Chinaday Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-06-26T07:00:00.000Z",
        endDate: "2019-06-27T07:00:00.000Z",
        urlFriendly: "chinaday-conference-2019",
      },
      {
        id: 1667,
        eventName: "Agrotech Conference 2019",
        address: "Rua José Bernardo Pinto, 333 - Vila Guilherme, São Paulo - SP, 02055-000",
        startDate: "2019-06-27T07:00:00.000Z",
        endDate: "2019-06-28T07:00:00.000Z",
        urlFriendly: "agrotech-conference-2019",
      }],
      loaded: false,
      error: false
    }
  }

  componentDidMount () {
    this.setState({ eventsFiltered: this.state.events.filter(x => moment(x.endDate) >= moment()) })
  }

  render () {
    document.title = this.state.organizador.name ? this.state.organizador.name + ' - Evnts' : 'Carregando...'

    return (
      <div>
        <main>
          <Header />
          <section id='hotels'>
            {this.state.eventsFiltered && (this.state.eventsFiltered).map(event => <ShowCard key={event.id} organizador={this.state.organizador.id} {...event} />)}
          </section>
        </main>
        <Footer />
      </div>
    )
  }
}
